import axios from 'axios';
import {backendHost} from '../../config';

export const postMedia = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/media`, params);
};